// For small size
const wallStructure1ImageSm = require("../../../assets/images/products/subproducts/wall-structure-smallSize/1.png");
const wallStructure2ImageSm = require("../../../assets/images/products/subproducts/wall-structure-smallSize/2.png");
const wallStructure3ImageSm = require("../../../assets/images/products/subproducts/wall-structure-smallSize/3.png");
const wallStructure4ImageSm = require("../../../assets/images/products/subproducts/wall-structure-smallSize/4.png");
const wallStructure5ImageSm = require("../../../assets/images/products/subproducts/wall-structure-smallSize/5.png");
const wallStructure6ImageSm = require("../../../assets/images/products/subproducts/wall-structure-smallSize/6.png");
const wallStructure7ImageSm = require("../../../assets/images/products/subproducts/wall-structure-smallSize/7.png");
const wallStructure8ImageSm = require("../../../assets/images/products/subproducts/wall-structure-smallSize/8.png");
const wallStructure9ImageSm = require("../../../assets/images/products/subproducts/wall-structure-smallSize/9.png");
const wallStructure10ImageSm = require("../../../assets/images/products/subproducts/wall-structure-smallSize/10.png");
const wallStructure11ImageSm = require("../../../assets/images/products/subproducts/wall-structure-smallSize/11.png");
const wallStructure12ImageSm = require("../../../assets/images/products/subproducts/wall-structure-smallSize/12.png");
const wallStructure13ImageSm = require("../../../assets/images/products/subproducts/wall-structure-smallSize/13.png");
const wallStructure14ImageSm = require("../../../assets/images/products/subproducts/wall-structure-smallSize/14.png");
const wallStructure15ImageSm = require("../../../assets/images/products/subproducts/wall-structure-smallSize/15.png");
const wallStructure16ImageSm = require("../../../assets/images/products/subproducts/wall-structure-smallSize/16.png");
const wallStructure17ImageSm = require("../../../assets/images/products/subproducts/wall-structure-smallSize/17.png");
const wallStructure18ImageSm = require("../../../assets/images/products/subproducts/wall-structure-smallSize/18.png");
const wallStructure19ImageSm = require("../../../assets/images/products/subproducts/wall-structure-smallSize/19.png");
const wallStructure20ImageSm = require("../../../assets/images/products/subproducts/wall-structure-smallSize/20.png");

const wallStructure1Image = require("../../../assets/images/products/subproducts/wall-structure-slider/1.png");
const wallStructure2Image = require("../../../assets/images/products/subproducts/wall-structure-slider/2.png");
const wallStructure3Image = require("../../../assets/images/products/subproducts/wall-structure-slider/3.png");
const wallStructure4Image = require("../../../assets/images/products/subproducts/wall-structure-slider/4.png");
const wallStructure5Image = require("../../../assets/images/products/subproducts/wall-structure-slider/5.png");
const wallStructure6Image = require("../../../assets/images/products/subproducts/wall-structure-slider/6.png");
const wallStructure7Image = require("../../../assets/images/products/subproducts/wall-structure-slider/7.png");
const wallStructure8Image = require("../../../assets/images/products/subproducts/wall-structure-slider/8.png");
const wallStructure9Image = require("../../../assets/images/products/subproducts/wall-structure-slider/9.png");
const wallStructure10Image = require("../../../assets/images/products/subproducts/wall-structure-slider/10.png");
const wallStructure11Image = require("../../../assets/images/products/subproducts/wall-structure-slider/11.png");
const wallStructure12Image = require("../../../assets/images/products/subproducts/wall-structure-slider/12.png");
const wallStructure13Image = require("../../../assets/images/products/subproducts/wall-structure-slider/13.png");
const wallStructure14Image = require("../../../assets/images/products/subproducts/wall-structure-slider/14.png");
const wallStructure15Image = require("../../../assets/images/products/subproducts/wall-structure-slider/15.png");
const wallStructure16Image = require("../../../assets/images/products/subproducts/wall-structure-slider/16.png");
const wallStructure17Image = require("../../../assets/images/products/subproducts/wall-structure-slider/17.png");
const wallStructure18Image = require("../../../assets/images/products/subproducts/wall-structure-slider/18.png");
const wallStructure19Image = require("../../../assets/images/products/subproducts/wall-structure-slider/19.png");
const wallStructure20Image = require("../../../assets/images/products/subproducts/wall-structure-slider/20.png");

export const ProductsGalleryArray = [
  {
    id: 1,
    imageBanner: wallStructure1Image,
    imageSlider: wallStructure1ImageSm,
  },
  {
    id: 2,
    imageBanner: wallStructure2Image,
    imageSlider: wallStructure2ImageSm,
  },
  {
    id: 3,
    imageBanner: wallStructure3Image,
    imageSlider: wallStructure3ImageSm,
  },
  {
    id: 4,
    imageBanner: wallStructure4Image,
    imageSlider: wallStructure4ImageSm,
  },
  {
    id: 5,
    imageBanner: wallStructure5Image,
    imageSlider: wallStructure5ImageSm,
  },
  {
    id: 6,
    imageBanner: wallStructure6Image,
    imageSlider: wallStructure6ImageSm,
  },
  {
    id: 7,
    imageBanner: wallStructure7Image,
    imageSlider: wallStructure7ImageSm,
  },
  {
    id: 8,
    imageBanner: wallStructure8Image,
    imageSlider: wallStructure8ImageSm,
  },
  {
    id: 9,
    imageBanner: wallStructure9Image,
    imageSlider: wallStructure9ImageSm,
  },
  {
    id: 10,
    imageBanner: wallStructure10Image,
    imageSlider: wallStructure10ImageSm,
  },
  {
    id: 11,
    imageBanner: wallStructure11Image,
    imageSlider: wallStructure11ImageSm,
  },
  {
    id: 12,
    imageBanner: wallStructure12Image,
    imageSlider: wallStructure12ImageSm,
  },
  {
    id: 13,
    imageBanner: wallStructure13Image,
    imageSlider: wallStructure13ImageSm,
  },
  {
    id: 14,
    imageBanner: wallStructure14Image,
    imageSlider: wallStructure14ImageSm,
  },
  {
    id: 15,
    imageBanner: wallStructure15Image,
    imageSlider: wallStructure15ImageSm,
  },
  {
    id: 16,
    imageBanner: wallStructure16Image,
    imageSlider: wallStructure16ImageSm,
  },
  {
    id: 17,
    imageBanner: wallStructure17Image,
    imageSlider: wallStructure17ImageSm,
  },
  {
    id: 18,
    imageBanner: wallStructure18Image,
    imageSlider: wallStructure18ImageSm,
  },
  {
    id: 19,
    imageBanner: wallStructure19Image,
    imageSlider: wallStructure19ImageSm,
  },
  {
    id: 20,
    imageBanner: wallStructure20Image,
    imageSlider: wallStructure20ImageSm,
  },
];
